(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('change', (event) => {
  const select = event.target;
  if (!(select instanceof HTMLSelectElement) || !select.id.startsWith('ProductVariant-')) return;
  const price = select.closest('.product-details')?.querySelector('.product-price');
  if (price && select.selectedOptions[0]?.dataset.price) price.textContent = select.selectedOptions[0].dataset.price;
});

  } catch(e) { console.error(e); }
})();
})();
